import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import home from './home'
import error from './error'
import account from './account'
import systemAdmin from './system/admin'
import systemModule from './system/module'
import systemRole from './system/role'
import merchantBill from './merchant/bill'
import merchantManage from './merchant/manage'
import merchantRecharge from './merchant/recharge'
import childrenSystem from './system/childrenSystem'
import checkUserAccount from './antiChannelConflict/checkUserAccount'
import antiChannelConflictDealer from './antiChannelConflict/dealer'
import antiChannelConflictDealerLevel from './antiChannelConflict/dealerLevel'
import antiChannelConflictInStock from './antiChannelConflict/inStock'
import antiChannelConflictOutStock from './antiChannelConflict/outStock'
import antiChannelConflictPDAAccount from './antiChannelConflict/pdaAccount'
import antiChannelConflictPackingRule from './antiChannelConflict/packingRule'
import antiChannelConflictProductReturn from './antiChannelConflict/productReturn'
import antiChannelConflictWarehouse from './antiChannelConflict/warehouse'
import antiChannelConflictStock from './antiChannelConflict/stock'
import antiFakeCode from './antiFake/code'
import antiFakeQuery from './antiFake/query'
import antiFakeResponse from './antiFake/response'
import issuerCode from './issuerCodes/code'
import issuerRecord from './issuerCodes/record'
import productBrand from './products/brand'
import productOrder from './products/order'
import productProducts from './products/product'
import systemPayment from './system/payment'
import systemSms from './system/sms'
import systemAliyun from './system/aliyunsms'
import mallDeliveryTemplate from './mall/deliveryTemplate'
import productsProductCategory from './products/productCategory'
import productsproductPropertyCategory from './products/productPropertyCategory'
import productsproductProperty from './products/productProperty'
import systemSiteProps from './system/siteProps'
import systemOfficialAccount from './system/officialAccount'
import systemScheduling from './system/scheduling'
import userManageUser from './userManage/user'
import areasArea from './areas/area'
import basicAdvert from './basic/advert'
import basicExpress from './basic/express'
import mallServicePromise from './mall/servicePromise'
import mallOrder from './mall/order'
import systemTemplateMessage from './system/templateMessage'
import antiChannelConflictAntiChannelConflictCode from './antiChannelConflict/antiChannelConflictCode'
import antiChannelConflictAntiChannelConflictQuery from './antiChannelConflict/antiChannelConflictQuery'
import mallProduct from './mall/mallProduct'
import mallProductBrand from './mall/mallBrand'
import mallProductCategory from './mall/mallProductCategory'
import mallProductProperty from './mall/mallProductProperty'
import mallProductPropertyCategory from './mall/mallProductPropertyCategory'
import replenishOrder from './replenishment/replenishOrder'
import replenishProduct from './replenishment/replenishProduct'
import replenishmentDeliveryTemplate from './replenishment/deliveryTemplate'
import replenishProductBrand from './replenishment/replenishProductBrand'
import replenishProductCategory from './replenishment/replenishProductCategory'
import replenishProductProperty from './replenishment/replenishProductProperty'
import replenishProductPropertyCategory from './replenishment/replenishProductPropertyCategory'
import replenishProductPropertyValue from './replenishment/replenishProductPropertyValue'
import officialAccountsMenu from './officialAccounts/menu'
import marketingActivity from './marketing/activity'
import marketingActivityUserGranty from './marketing/activityUserGrant'
import marketingAward from './marketing/award'
import marketingLotteryRecord from './marketing/lotteryRecord'
import marketingRedPacketDate from './marketing/RedPacketDate'
import marketingFreeAwardInformation from './marketing/freeAwardInformation'
import marketingHelpAwardTotal from './marketing/HelpAwardTotal'
import marketingChart from './marketing/Chart'
import marketingKadierInfo from './marketing/kadierInfo'
import marketingMandiInfo from './marketing/mandiInfo'
import exhibitionHallActivity from './exhibitionHall/activity'
import exhibitionHallActivityUser from './exhibitionHall/activityUser'
import exhibitionHallAward from './exhibitionHall/award'
import exhibitionHallWinner from './exhibitionHall/winner'
import updaterResource from './updater/resource'
import antiChannelConflictdealerUpdate from './antiChannelConflict/dealerUpdate'
import salesPOSSeller from './sales/posSeller'
import salesAreaManager from './sales/areaManager'
import salesPOS from './sales/pos'
import integral from './mall/integral'
import wechatExcellentProductDealer from './wechatExcellent/productDealer'
import wechatExcellentDealerBlack from './wechatExcellent/dealerBlack'
import wechatExcellentJoinInApply from './wechatExcellent/joinInApply'
import wechatExcellentNews from './wechatExcellent/news'
import wechatExcellentDealerStock from './wechatExcellent/dealerStock'
import wechatExcellentOrder from './wechatExcellent/order'
import wechatExcellentInvoice from './wechatExcellent/invoice'
import wechatExcellentConsumerFeedback from './wechatExcellent/consumerFeedback'
import wechatExcellentMessage from './wechatExcellent/message'
import wechatExcellentProductExtend from './wechatExcellent/productExtend'
import wechatExcellentReport from './wechatExcellent/report'
import systemExtendModule from './system/extendModule.js'
import challengeManageChallenge from './challengeManage/challenge.js'
import jinluxinProduct from './jinluxin/product'
import systemMiniProgramConfig from './system/miniProgramConfig'
import marketingCamera from './marketing/camera'
import agent from './marketing/agent'
import supermarket from './marketing/supermarket'
import marketingAction from './marketing/marketingAction'
import marketingImages from './marketing/marketingImages'
import ywtProduct from './ywt/product'
import ywtIntegral from './ywt/integral'
import ywtProductCategory from './ywt/productCategory'
import ywtMember from './ywt/member'
import ywtInstallRegister from './ywt/installRegister'
import ywtServiceOrder from './ywt/serviceOrder'
import ywtCustomer from './ywt/customer'
import systemNewSms from './system/newSms'
import autoTable from './autoTable/table'

Vue.use(Router)

const router = new Router({
  routes: [
    ...home,
    ...error,
    ...account,
    ...systemRole,
    ...systemAdmin,
    ...systemModule,
    ...merchantBill,
    ...merchantManage,
    ...merchantRecharge,
    ...childrenSystem,
    ...antiChannelConflictDealer,
    ...antiChannelConflictDealerLevel,
    ...antiChannelConflictInStock,
    ...antiChannelConflictOutStock,
    ...antiChannelConflictPDAAccount,
    ...antiChannelConflictPackingRule,
    ...antiChannelConflictProductReturn,
    ...antiChannelConflictWarehouse,
    ...antiChannelConflictStock,
    ...antiFakeCode,
    ...antiFakeQuery,
    ...antiFakeResponse,
    ...issuerCode,
    ...issuerRecord,
    ...productBrand,
    ...productOrder,
    ...productProducts,
    ...systemPayment,
    ...systemSms,
    ...systemAliyun,
    ...mallDeliveryTemplate,
    ...productsProductCategory,
    ...productsproductPropertyCategory,
    ...productsproductProperty,
    ...systemSiteProps,
    ...systemOfficialAccount,
    ...systemScheduling,
    ...userManageUser,
    ...areasArea,
    ...basicAdvert,
    ...basicExpress,
    ...mallServicePromise,
    ...mallOrder,
    ...systemTemplateMessage,
    ...antiChannelConflictAntiChannelConflictCode,
    ...antiChannelConflictAntiChannelConflictQuery,
    ...mallProduct,
    ...mallProductBrand,
    ...mallProductCategory,
    ...mallProductProperty,
    ...mallProductPropertyCategory,
    ...replenishOrder,
    ...replenishProduct,
    ...replenishmentDeliveryTemplate,
    ...replenishProductBrand,
    ...replenishProductCategory,
    ...replenishProductProperty,
    ...replenishProductPropertyCategory,
    ...replenishProductPropertyValue,
    ...officialAccountsMenu,
    ...marketingActivity,
    ...marketingActivityUserGranty,
    ...marketingAward,
    ...marketingLotteryRecord,
    ...marketingRedPacketDate,
    ...marketingFreeAwardInformation,
    ...marketingHelpAwardTotal,
    ...marketingChart,
    ...marketingMandiInfo,
    ...marketingKadierInfo,
    ...exhibitionHallActivity,
    ...exhibitionHallActivityUser,
    ...exhibitionHallAward,
    ...exhibitionHallWinner,
    ...updaterResource,
    ...checkUserAccount,
    ...updaterResource,
    ...antiChannelConflictdealerUpdate,
    ...salesPOSSeller,
    ...salesAreaManager,
    ...salesPOS,
    ...integral,
    ...wechatExcellentProductDealer,
    ...wechatExcellentDealerBlack,
    ...wechatExcellentJoinInApply,
    ...wechatExcellentNews,
    ...wechatExcellentDealerStock,
    ...wechatExcellentOrder,
    ...wechatExcellentInvoice,
    ...wechatExcellentConsumerFeedback,
    ...wechatExcellentMessage,
    ...wechatExcellentProductExtend,
    ...wechatExcellentReport,
    ...systemExtendModule,
    ...challengeManageChallenge,
    ...jinluxinProduct,
    ...systemMiniProgramConfig,
    ...marketingCamera,
    ...agent,
    ...supermarket,
    ...marketingAction,
    ...marketingImages,
    ...ywtProduct,
    ...ywtIntegral,
    ...ywtProductCategory,
    ...ywtMember,
    ...ywtInstallRegister,
    ...ywtServiceOrder,
    ...ywtCustomer,
    ...systemNewSms,
    ...autoTable
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    store.dispatch('account/getAccessToken')
    if (store.state.account.access_token) {
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
  store.dispatch('app/getSysTitle')
  window.document.title = store.state.app.systemTitle
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js